import axios from "axios";
import URLS from "./URLS";

const API_URL = URLS.API_URL;

const unAuthorizedMessageArr = ["Not Authorized", "Unauthorized access."];
class Axios {
  defaultOptions = () => {
    if (typeof window === "undefined") {
      return {
        baseURL: `${API_URL}`,
        headers: {
          token: "",
          adminId: "",
          Authorization: "",
        },
      };
    }
    return {
      baseURL: `${API_URL}`,
      headers: {
        Authorization: "Bearer" + " " + localStorage.getItem("token") || "",
        adminid: (localStorage && localStorage.getItem("_id")) || "",
        token: localStorage.getItem("token"),
      },
    };
  };

  LogoutUser = () => {
    localStorage.removeItem("token");
    window?.location?.replace("/");
  };

  checkResponse = (res) => {
    if (
      (res.data.message && unAuthorizedMessageArr.includes(res.data.message)) ||
      res?.status === 401
    ) {
      this.LogoutUser();
    } else {
      return res;
    }
  };

  get = (url, options = {}) => {
    return axios
      .get(url, { ...this.defaultOptions(), ...options })
      .then((res) => this.checkResponse(res))
      .catch((err) => {
        if (
          (err?.response && err?.response?.status === 401) ||
          (err?.response?.data?.data?.message &&
            unAuthorizedMessageArr.includes(err?.response?.data?.data?.message))
        ) {
          this.LogoutUser();
          return err.response;
        } else {
          return err.response;
        }
      });
  };

  post = (url, data, options = {}) => {
    return axios
      .post(url, data, { ...this.defaultOptions(), ...options })
      .then((res) => this.checkResponse(res))
      .catch((err) => {
        console.log(err, "check response");
        if (
          (err?.response && err?.response?.status === 401) ||
          (err?.response?.data?.data?.message &&
            unAuthorizedMessageArr.includes(err?.response?.data?.data?.message))
        ) {
          this.LogoutUser();
          return err.response;
        } else {
          return err.response;
        }
      });
  };

  put = (url, data, options = {}) => {
    return axios
      .put(url, data, { ...this.defaultOptions(), ...options })
      .then((res) => this.checkResponse(res))
      .catch((err) => {
        if (
          (err?.response && err?.response?.status === 401) ||
          (err?.response?.data?.data?.message &&
            unAuthorizedMessageArr.includes(err?.response?.data?.data?.message))
        ) {
          this.LogoutUser(err);
          return err.response;
        } else {
          return err.response;
        }
      });
  };

  patch = (url, data, options = {}) => {
    return axios
      .patch(url, data, { ...this.defaultOptions(), ...options })
      .then((res) => this.checkResponse(res))
      .catch((err) => {
        if (
          (err?.response && err?.response?.status === 401) ||
          (err?.response?.data?.data?.message &&
            unAuthorizedMessageArr.includes(err?.response?.data?.data?.message))
        ) {
          this.LogoutUser(err);
          return err.response;
        } else {
          return err.response;
        }
      });
  };

  delete = (url, options = {}) => {
    return axios
      .delete(url, { ...this.defaultOptions(), ...options })
      .then((res) => this.checkResponse(res))
      .catch((err) => {
        if (
          (err?.response && err?.response?.status === 401) ||
          (err?.response?.data?.data?.message &&
            unAuthorizedMessageArr.includes(err?.response?.data?.data?.message))
        ) {
          this.LogoutUser(err);
          return err.response;
        } else {
          return err.response;
        }
      });
  };
}

export default new Axios();
